import type { AuditEvent } from "../../types/payrollAdmin.js";
import { getPayrollAuditPresentation } from "../../lib/payrollAuditDisplay.js";

export const auditDate = (value: string) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const auditClock = (value: string) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const auditValue = (event: AuditEvent, key: string) =>
  event.context?.[key] ?? event.afterPayload?.[key];

export const EmployeeAuditTimelineItem = ({
  event,
  last,
}: {
  event: AuditEvent;
  last: boolean;
}) => {
  const presentation = getPayrollAuditPresentation(event);
  const actor = event.actorDisplayName || "System";
  return (
    <li className="relative grid grid-cols-[24px_minmax(0,1fr)] gap-3 px-4 py-4">
      <div className="relative flex justify-center">
        <span
          className="mt-1.5 size-2.5 rounded-full border-2 border-accent bg-surface shadow-[0_0_0_4px_var(--color-surface)]"
          aria-hidden="true"
        />
        {!last && (
          <span
            className="absolute bottom-[-1rem] top-4 w-px bg-border"
            aria-hidden="true"
          />
        )}
      </div>
      <article className="min-w-0">
        <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
          <p className="text-sm font-semibold text-foreground">
            {presentation.label}
          </p>
        </div>
        <p className="mt-1.5 text-sm leading-6 text-foreground-muted">
          {presentation.description}
        </p>
        <div className="mt-3 grid gap-2 rounded-lg bg-elevated/70 px-3 py-2.5 text-xs sm:grid-cols-3">
          <p className="min-w-0 text-foreground-muted">
            <span className="block text-foreground-subtle">Payroll month</span>
            <span className="mt-0.5 block font-medium text-foreground">
              {presentation.monthLabel}
            </span>
          </p>
          <p className="min-w-0 text-foreground-muted">
            <span className="block text-foreground-subtle">Changed</span>
            <span className="mt-0.5 block font-medium text-foreground">
              {auditDate(event.createdAt)} ·{" "}
              {auditClock(event.createdAt) || "—"}
            </span>
          </p>
          <p className="min-w-0 text-foreground-muted">
            <span className="block text-foreground-subtle">Changed by</span>
            <span
              className="mt-0.5 block truncate font-medium text-foreground"
              title={actor}
            >
              {actor}
            </span>
          </p>
        </div>
        {event.reason && (
          <p className="mt-2 rounded-lg bg-elevated px-3 py-2 text-xs leading-5 text-foreground-muted">
            <span className="font-medium text-foreground">Reason:</span>{" "}
            {event.reason}
          </p>
        )}
      </article>
    </li>
  );
};
